import React ,{useState} from "react";
import {connect} from 'dva';
import { Input, Button, Form, message } from 'antd';
import './EmailVerify.less'

function Verify (props) {
  const {dispatch,deployConfigInfo} = props;
  const {uid} = window.urlObject;
  const [status, setStatus] = useState(1);
  const [value1, setValue1] = useState('');
  const [value2, setValue2] = useState('');
  const [disabledBtn1, setDisabledBtn1] = useState(true);
  const [disabledBtn2, setDisabledBtn2] = useState(true);
  const { getFieldDecorator, getFieldError } = props.form;

  function change1 (e) {
    e.preventDefault();
    setDisabledBtn1(!e.target.value)
    setValue1(e.target.value)
  }
  function change2 (e) {
    e.preventDefault();
    setDisabledBtn2(e.target.value.length !== 6)
    setValue2(e.target.value)
  }
  function sendEmail (e) {
    e.preventDefault();
    if (getFieldError('email') || !value1) {
      message.error('请输入正确的邮箱');
      return
    }
    dispatch({
      type: 'leaveMsg/sendShortEmailMessage',
      payload: {
          email: value1
      },
      callback: function (ret) {
        if(ret && ret.retCode === '1') {
            setStatus(3)
        } else {
            message.warn(ret.retMsg || '邮件发送失败');
        }
      }
    })
  }
  function verify (e) {
    e.preventDefault();
    dispatch({
      type: 'leaveMsg/verifyShortEmailMessage',
      payload: {
          email: value1,
          code: value2
      },
      callback: function (ret) {
        if(ret && ret.retCode === '1') {
            sessionStorage.setItem('verifyEmail', value1)
            dispatch({
              type: 'leaveMsg/getMsgRecordList',
              payload: {
                  uid,
                  ticketScopeFlag: deployConfigInfo.item.ticketScopeFlag,
                  email: sessionStorage.getItem('verifyEmail') || ''
              }
            })
        } else {
            message.warn(ret.retMsg || '验证码错误');
        }
      }
    })
  }
  return (
    <>
      {
        function () {
          if (status === 1) {
            return (<div className="zc-email-verify">
            <p className="zc-no-data">没有查询到您的工单</p>
            <p>如您之前提交过工单，可通过邮箱验证查看</p>
            <p className="zc-verify" onClick={()=>{setStatus(2)}}>开始邮箱验证</p>
          </div>)
          } else if (status === 2) {
            return (<div className="zc-email-verify1">
              <Form layout="horizontal" style={{height:"110px"}}>
                <Form.Item label="请输入提交工单时使用的邮箱地址：">
                  {getFieldDecorator('email', {
                    rules: [
                      {
                        type: 'email',
                        message: '请输入正确的邮箱',
                      }
                    ],
                  })(<Input className="zc-verify-input" placeholder="请输入邮箱地址" maxLength={50} onChange={(e)=>{change1(e)}}/>)}
                </Form.Item>
              </Form>
              <Button type="primary" block disabled={disabledBtn1} onClick={(e)=>{sendEmail(e)}}>发送邮件</Button>
          </div>)
          } else if (status === 3) {
            return (<div className="zc-email-verify1">
              <Form layout="horizontal" style={{height:"110px"}}>
                <Form.Item label="邮件已发送，请输入您收到的验证码：">
                  <Input className="zc-verify-input" placeholder="请输入验证码" value={value2} maxLength={6} onChange={(e)=>{change2(e)}}/>
                </Form.Item>
              </Form>
              <Button type="primary" block disabled={disabledBtn2} onClick={(e)=>{verify(e)}}>立即查看</Button>
          </div>)
          }
        }()
      }
    </>
  )
}

function mapState(state) {
  const {deployConfigInfo} = state.app;
  return {
      deployConfigInfo
  }
}

export default connect(mapState)(Form.create({name: 'Verify'})(Verify));